import { BIControlPanel as BIControlPanelTranslations } from "./interfaces/BIControlPanel";
import { SupportedLanguages } from "@/lang/lang-settings";
import { ptBR } from "./translations/pt-BR"
import { enUS } from "./translations/en-US"

export const BIControlPanel: Record<SupportedLanguages, BIControlPanelTranslations> = {
  'pt-BR': ptBR,
  'en-US': enUS,
};
